import { Box, Container } from '@mui/material';
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import axios from "axios";
import { ApplicationLoader, useProfileContext } from '../../contexts';
import { GetUserData, VerifyUser } from '../../helpers/api.helpers';
import { TeamsystemAppBar } from '../TeamsystemAppBar';
import css from './ProtectedAppOutlet.module.css';
import { EnvironmentAlerts } from '../../features/EnvironmentAlerts';

const useProtectedOutletController = () => {

    const navigate = useNavigate();
    const [profile, setProfile] = useProfileContext();
    const [loader, setLoader] = React.useState(null);
    const hasHandledErrorRef = React.useRef(false);

    React.useEffect(() => {

        const load = async () => {
            try {
                setLoader(true);

                await VerifyUser();
                const userProfile = await GetUserData();

                setProfile(userProfile.data);
                setLoader(false);

            } catch (err) {

                setLoader(false);

                if (hasHandledErrorRef.current) return;
                hasHandledErrorRef.current = true;

                if (axios.isAxiosError(err)) {

                    const code = err.response?.status || 500;
                    const title = err.response?.data?.title || "500";

                    if (code === 401) {
                        navigate("/errors", { state: { code: 401 }, replace: true });
                    }
                    else if (title === "404.1004") {
                        navigate("/errors/1004", { replace: true });
                    }
                    else {
                        navigate("/errors", { state: { code }, replace: true });
                    }

                } else {
                    navigate("/errors", { state: { code: 500 }, replace: true });
                }
            }
        };

        load();

    }, []);

    return {
        models: {
            loader,
            profile
        }
    };
};

export const ProtectedAppOutlet = () => {

    const { models } = useProtectedOutletController();

    return (
        <Box className={css.protectedAppOutletContainer}>
            <Box className={css.protectedAppOutletWrapper}>
                {(models.loader === false) ? (
                    <Box height="100vh" width="100%" display="flex" flexDirection="column">
                        <TeamsystemAppBar hideActions={!models?.profile?.email} />
                        <EnvironmentAlerts />
                        <Box
                            display="flex"
                            flexDirection="column"
                            sx={{
                                flexGrow: 1,
                                overflow: 'auto',
                            }}
                        >
                            <Outlet />
                        </Box>
                    </Box>
                ) : (
                    <Container maxWidth="lg">
                        <ApplicationLoader loader={models.loader} />
                    </Container>
                )}
            </Box>
        </Box>
    );
};